var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"testbed-message-root"},_vm._l((_vm.$messages.messages),function(message){return _c('MessageWidget',{key:message.id,attrs:{"message":message}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }